module.exports = __webpack_public_path__ + "media/customizations/lmhh/logo-7d4404b816cbe43fa4d21ae4451a11a1.png";